const hideSingleFilters_desktop = () => {
//    $('.top-facet-column').each(function() {
//        if ($(this).find('ul.facet').children().length < 2)
//            $(this).remove();
//    });
}

const hideSingleFilters_mt = () => {
//    $('.side-facet').each(function() {
//        if ($(this).find('ul.facet').children().length < 2)
//            $(this).remove();
//    });
}

export {
    hideSingleFilters_desktop,
    hideSingleFilters_mt
}
